<template>
    <div id="index" class="layout">
        <Layout>
            <Header>
              <Menu mode="horizontal" theme="dark" @on-select="logOut">
                <div class="layout-logo"></div>
                <div class="layout-nav">
                    
                  <MenuItem name="logOut">
                    <Icon type="log-out"></Icon>
                    Log Out
                  </MenuItem>
                </div>
              </Menu>
            </Header>
            <Layout>
                <Sider hide-trigger :style="{background: '#fff',height: '92vh'}">
                  <Menu :active-name="activeName" theme="light" width="auto" :open-names="['1']" @on-select="menu">
                    <Submenu name="1">
                      <template slot="title">
                        客戶
                      </template>
                      <MenuItem name="teamList">客戶資料簿</MenuItem>
                      <MenuItem name="teamCreate">新增客戶</MenuItem>
                    </Submenu>
                    <MenuItem name="bill">應收帳款</MenuItem>
                    <MenuItem name="transactionList">派車單統計</MenuItem>
                  </Menu>
                </Sider>
                <Layout :style="{padding: '0 24px 24px'}">
                    <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
                        <router-view></router-view>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import { Axios, API } from "@/assets/config"

export default {
  name: "index",
  data() {
    return {
      activeName: 'teamList',
      menuName: ['teamList','teamCreate','bill','transactionList']
    }
  },
  created() {
    this.setAxios(localStorage.getItem('token'))
    this.$router.push({name: 'teamList'})
  },
  watch:{
    $route (to, from){
      if(this.menuName.indexOf(to.name) !== -1)
        this.activeName = to.name
    }
  },
  methods: {
    menu(name) {
      this.$router.push({name})
    },
    logOut() {
      localStorage.clear()
      this.$router.push({name: 'login'})
    }
  }
}
</script>

<style lang="scss" scoped>
.layout{
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
}
.layout-logo{
    width: 100px;
    height: 30px;
    background: #5b6270;
    border-radius: 3px;
    float: left;
    position: relative;
    top: 15px;
    left: 20px;
}
.layout-nav{
    width: 420px;
    margin: 0 auto;
    margin-right: 20px;
    .ivu-menu-item {
        float: right;
    }
}

.ivu-layout-header {
  height: 7vh;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue